<template>
  <div class="estate-detail">
    <header-top showBack haveTab></header-top>
    <el-tabs
      v-model="activeTab"
      @tab-click="handleTabChange"
    >
      <el-tab-pane label="业务信息" name="业务信息">
        <service-info />
      </el-tab-pane>
      <el-tab-pane label="营销管理" name="营销管理">
        <marketing-management ref="markManage" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import serviceInfo from "./service-info/index.vue";
import marketingManagement from "./marketing-management";

export default {
  components: {
    headerTop,
    serviceInfo,
    marketingManagement
  },
  data() {
    return {
      id: this.$route.params.id,
      activeTab:'业务信息',
      active:''
    };
  },
  methods: {
    handleTabChange(v){
      if(v.name=='营销管理'&&this.active!='营销管理'){
        this.$refs.markManage.initData();
        this.active='营销管理';
      }
    }
  },
  mounted(){
    document.querySelector(".main-container").scrollTo(0,0);
  }
};
</script>

<style lang="scss" scoped>

</style>